// removed by extract-text-webpack-plugin
module.exports = {"a":"Anchor__a___3JUCG"};


//////////////////
// WEBPACK FOOTER
// ./src/Anchor.css
// module id = 1
// module chunks = 0 1